// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5820) return "static/chunks/5820-dcabc0cc3e79ba17.js";
	if (chunkId === 490) return "static/chunks/490-d04306f50011c6c7.js";
	if (chunkId === 6161) return "static/chunks/6161-5f7cfcfc694595cb.js";
	if (chunkId === 7360) return "static/chunks/7360-4c687d8eaf2ec738.js";
	if (chunkId === 8710) return "static/chunks/8710-b5c3614eeadb442b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"278":"4910c34ba1a3c9b7","569":"35912496f1c7af89","2565":"8550a40cd4c74632","2627":"d8fd611ac836a081","6654":"32ea34e1ace1a35e","9383":"b7ab3929ee9ab3f5"}[chunkId] + ".js";
};